import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-delete-modal',
  imports: [TranslateModule],
  templateUrl: './delete-modal.component.html',
  styleUrl: './delete-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DeleteModalComponent {
  message: string;

  constructor(
    private modalRef: NzModalRef,
    @Inject(NZ_MODAL_DATA) public data: { message: string }
  ) {
    this.message = data.message;
  }

  confirmDelete(): void {
    this.modalRef.close(true);
  }

  cancel(): void {
    this.modalRef.close(false);
  }
}
